<template>
	<time :datetime="datetime" :title="datetime">
		{{ formatted }}
	</time>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
	datetime: string;
}>();

const formatted = computed(() => new Date(props.datetime).toLocaleString());
</script>
